<div class="tw-flex tw-flex-col tw-gap-4">
  <div class="tw-flex tw-w-full tw-p-1 tw-bg-color-segmented-container-bg tw-rounded-2xl tw-gap-1">
    <app-tab-button
      class="tw-flex tw-flex-1"
      [label]="'usePlatinumCredits' | i18n"
      [isActive]="tab() === 'platinum'"
      [activeBg]="'var(--color-surface-elevated)'"
      [segmented]="true"
      (tabClick)="setTab('platinum')"
    ></app-tab-button>
    <app-tab-button
      class="tw-flex tw-flex-1"
      [label]="'buyWithCash' | i18n"
      [isActive]="tab() === 'cash'"
      [activeBg]="'var(--color-surface-elevated)'"
      [segmented]="true"
      (tabClick)="setTab('cash')"
    ></app-tab-button>
  </div>

  @if (tab() === "cash") {
    <section class="tw-flex tw-flex-col tw-gap-3">
      <div
        class="tw-flex tw-flex-col tw-gap-3 tw-rounded-2xl tw-bg-white/40 dark:tw-bg-white/[0.06] tw-p-4"
      >
        <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
          <span class="tw-text-sm tw-font-medium tw-text-color-text-default">
            {{ "chooseACreditPack" | i18n }}
          </span>
          <span
            class="tw-inline-flex tw-items-center tw-justify-center tw-h-[28px] tw-px-2 tw-rounded-full tw-bg-color-status-info-bg tw-text-[13px] tw-font-medium tw-leading-none tw-tracking-normal tw-text-color-status-info-text tw-whitespace-nowrap"
          >
            {{ "amazonGiftCardExchangeRate" | i18n: (exchangeRate | number) }}
          </span>
        </div>

        @if (isLoadingPacks()) {
          <div class="tw-flex tw-justify-center tw-py-6">
            <span class="tw-text-sm tw-text-neutral-500">{{ "loadingPacks" | i18n }}</span>
          </div>
        }

        <div class="tw-flex tw-flex-col tw-gap-2">
          @for (pack of packs(); track pack.productId) {
            @let isSelected = selectedPack()?.productId === pack.productId;
            <button
              type="button"
              (click)="selectPack(pack)"
              class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-rounded-xl tw-border-[1.5px] tw-py-[10px] tw-px-3 tw-bg-color-surface-card tw-text-left tw-transition-colors"
              [ngClass]="
                isSelected ? 'tw-border-dt-text-today-primary' : 'tw-border-color-border-subtle'
              "
            >
              <div class="tw-flex tw-items-center tw-gap-3">
                <span
                  class="tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded-full tw-flex-shrink-0"
                  [ngClass]="
                    isSelected
                      ? 'tw-border-[6px] tw-border-color-border-action'
                      : 'tw-border-[1.5px] tw-border-color-border-strong'
                  "
                ></span>
                <span class="tw-flex tw-items-center tw-gap-1.5">
                  <span
                    class="tw-text-[13px] tw-font-semibold tw-leading-[100%] tw-tracking-normal tw-text-color-text-default"
                  >
                    {{ pack.label }}
                  </span>
                  @if (pack.productId === bestValueProductId()) {
                    <span
                      class="tw-text-[10px] tw-font-semibold tw-uppercase tw-text-color-text-action"
                    >
                      {{ "bestValue" | i18n }}
                    </span>
                  }
                </span>
              </div>
              <span class="tw-flex tw-items-baseline tw-gap-1 tw-whitespace-nowrap">
                <span
                  class="tw-font-D-DIN-PRO tw-font-semibold tw-text-[14px] tw-leading-none tw-tracking-normal tw-text-color-text-secondary"
                >
                  {{ pack.price | number: "1.2-2" }}
                </span>
                <span
                  class="tw-font-medium tw-text-[12px] tw-leading-[100%] tw-tracking-normal tw-text-color-text-tertiary"
                >
                  {{ pack.currency }}
                </span>
              </span>
            </button>
          }
        </div>

        <span
          class="tw-text-[12px] tw-font-medium tw-leading-[100%] tw-tracking-normal tw-text-color-text-secondary"
        >
          {{ "purchaseViaCaption" | i18n: (minPackCredits() | number) }}
        </span>
      </div>

      <div
        class="tw-flex tw-flex-col tw-gap-3 tw-rounded-2xl tw-bg-white/40 dark:tw-bg-white/[0.06] tw-p-4"
      >
        <span
          class="tw-text-[13px] tw-font-medium tw-uppercase tw-tracking-normal tw-text-color-text-secondary"
        >
          {{ "paymentMethod" | i18n }}
        </span>

        @if (!isIOS) {
          <!-- Display-only: the payment method is dictated by platform, not user-selectable
               here, so this is a <div> rather than a <button> with nothing to click. -->
          <div
            class="tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-pt-3 tw-pr-3 tw-pb-3 tw-pl-4 tw-bg-color-surface-sunken"
          >
            <icon [size]="5" [name]="'card'"></icon>
            <span
              class="tw-font-semibold tw-text-[14px] tw-leading-none tw-tracking-normal tw-text-color-text-default"
              >Stripe</span
            >
            <img
              src="images/stripe-link-badge.png"
              alt="Pay with Link"
              class="tw-w-[97.89px] tw-h-[26px] tw-flex-shrink-0"
            />
          </div>
        }

        @if (isIOS) {
          <!-- Display-only: the payment method is dictated by platform, not user-selectable
               here, so this is a <div> rather than a <button> with nothing to click. -->
          <div
            class="tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-pt-3 tw-pr-3 tw-pb-3 tw-pl-4 tw-bg-color-surface-sunken"
          >
            <span
              class="tw-font-semibold tw-text-[14px] tw-leading-none tw-tracking-normal tw-text-color-text-default"
              >Apple Pay</span
            >
            <svg class="tw-w-12 tw-h-7 tw-flex-shrink-0">
              <use [attr.xlink:href]="'images/sprite.svg#apple-pay-badge'"></use>
            </svg>
          </div>
        }
      </div>

      <div
        class="tw-flex tw-flex-col tw-gap-3 tw-rounded-2xl tw-bg-white/40 dark:tw-bg-white/[0.06] tw-p-4"
      >
        <span
          class="tw-text-[13px] tw-font-medium tw-uppercase tw-tracking-normal tw-text-color-text-secondary"
        >
          {{ "summary" | i18n }}
        </span>
        <div class="tw-flex tw-items-center tw-justify-between">
          <span class="tw-text-sm tw-font-medium tw-text-color-text-secondary">
            {{ "goldCreditsAdded" | i18n }}
          </span>
          <span class="tw-flex tw-items-baseline tw-gap-1 tw-whitespace-nowrap">
            <span
              class="tw-font-D-DIN-PRO tw-font-semibold tw-text-[14px] tw-leading-none tw-tracking-normal tw-text-color-text-default"
            >
              +{{ selectedPack()?.credits ?? 0 | number }}
            </span>
            <span
              class="tw-font-medium tw-text-[12px] tw-leading-[100%] tw-tracking-normal tw-text-color-text-tertiary"
            >
              CrG
            </span>
          </span>
        </div>
        <div class="tw-flex tw-items-center tw-justify-between">
          <span class="tw-text-sm tw-font-medium tw-text-color-text-secondary">{{
            "youPay" | i18n
          }}</span>
          <span class="tw-flex tw-items-baseline tw-gap-1 tw-whitespace-nowrap">
            <span
              class="tw-font-D-DIN-PRO tw-font-semibold tw-text-[14px] tw-leading-none tw-tracking-normal tw-text-color-text-default"
            >
              {{ selectedPack()?.price ?? 0 | number: "1.2-2" }}
            </span>
            <span
              class="tw-font-medium tw-text-[12px] tw-leading-[100%] tw-tracking-normal tw-text-color-text-tertiary"
            >
              {{ selectedPack()?.currency }}
            </span>
          </span>
        </div>
        <div class="tw-flex tw-items-center tw-justify-between">
          <span class="tw-text-sm tw-font-semibold tw-text-color-text-default">
            {{ "newGoldBalance" | i18n }}
          </span>
          <span class="tw-flex tw-items-baseline tw-gap-1 tw-whitespace-nowrap">
            <span
              class="tw-font-D-DIN-PRO tw-font-semibold tw-text-[14px] tw-leading-none tw-tracking-normal tw-text-color-text-default"
            >
              {{ newGoldBalancePreview() | number }}
            </span>
            <span
              class="tw-font-medium tw-text-[12px] tw-leading-[100%] tw-tracking-normal tw-text-color-text-tertiary"
            >
              CrG
            </span>
          </span>
        </div>
        <span class="tw-text-sm tw-font-medium tw-text-color-text-secondary">
          {{ "chargedToPaymentMethodAbove" | i18n }}
        </span>
      </div>

      <button
        type="button"
        (click)="continueToPayment()"
        [disabled]="!selectedPack() || buyingPackId() !== null"
        [style.background]="glassButtonBg"
        [style.box-shadow]="glassButtonShadow"
        class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-w-full tw-h-[56px] tw-px-8 tw-py-3 tw-rounded-2xl tw-border-[1.5px] tw-border-white/60 dark:tw-border-white/[0.18] tw-text-[16px] tw-font-semibold tw-leading-[24px] tw-tracking-[0.005em] tw-text-color-text-on-action disabled:tw-opacity-50"
      >
        {{ buyingPackId() ? ("processing" | i18n) : ("continueToPayment" | i18n) }}
      </button>
    </section>
  } @else {
    <section class="tw-flex tw-flex-col tw-gap-4">
      <div
        class="tw-flex tw-flex-col tw-gap-4 tw-rounded-2xl tw-bg-white/40 dark:tw-bg-white/[0.06] tw-p-4"
      >
        <div class="tw-flex tw-flex-col tw-gap-2">
          <span
            class="tw-text-[11px] tw-font-semibold tw-tracking-wide tw-uppercase tw-text-color-text-tertiary"
          >
            {{ "platinumToConvert" | i18n }}
          </span>
          <div class="tw-flex tw-justify-end tw-gap-2">
            @for (percent of quickPercents; track percent) {
              <button
                type="button"
                (click)="onChipClick(percent)"
                [disabled]="!hasPlatinumBalance()"
                class="tw-w-[60px] tw-h-[26px] tw-flex tw-items-center tw-justify-center tw-rounded-full tw-text-[12px] tw-font-medium tw-transition-colors disabled:tw-opacity-50"
                [ngClass]="
                  isChipActive(percent)
                    ? 'tw-bg-color-text-action tw-text-color-text-on-action tw-shadow-elevation-card'
                    : 'tw-bg-color-surface-input tw-text-color-text-secondary'
                "
              >
                {{ percent === 1 ? "Max" : percent * 100 + "%" }}
              </button>
            }
          </div>

          <input
            type="range"
            class="pp-slider"
            [min]="0"
            [max]="totalPlatinum()"
            [value]="platinumAmount()"
            [style.background]="sliderFill()"
            [disabled]="!hasPlatinumBalance()"
            (input)="onSliderInput($event)"
          />

          <div class="tw-flex tw-items-center tw-justify-between">
            <span
              class="tw-font-semibold tw-text-[13px] tw-leading-[100%] tw-tracking-normal tw-text-color-text-tertiary"
            >
              0
            </span>
            <span class="tw-flex tw-items-baseline tw-gap-1">
              <span
                class="tw-font-semibold tw-text-[16px] tw-leading-[100%] tw-tracking-normal tw-text-color-action-primary"
              >
                {{ totalPlatinum() | number }}
              </span>
              <span
                class="tw-font-semibold tw-text-[12px] tw-leading-[100%] tw-tracking-normal tw-text-color-action-primary"
              >
                CrP
              </span>
            </span>
          </div>

          <div
            class="tw-flex tw-items-center tw-justify-between tw-mt-2 tw-h-[56px] tw-px-4 tw-py-3 tw-rounded-xl tw-border tw-border-dt-text-today-primary tw-bg-color-surface-input tw-shadow-elevation-input"
          >
            <input
              #amountInput
              type="number"
              inputmode="numeric"
              [value]="platinumAmount() ? platinumAmount() : null"
              [disabled]="!hasPlatinumBalance()"
              (input)="onAmountInput($event)"
              (change)="onAmountCommit($event)"
              class="tw-w-24 tw-bg-transparent tw-text-2xl tw-font-semibold tw-font-D-DIN-PRO tw-leading-none tw-tracking-normal tw-text-color-text-default tw-border-none tw-outline-none"
            />
            <span
              class="tw-text-[13px] tw-font-medium tw-leading-[100%] tw-tracking-normal tw-text-color-text-secondary"
            >
              CrP
            </span>
          </div>

          <span
            class="tw-inline-flex tw-items-center tw-justify-end tw-self-end tw-h-[28px] tw-gap-3 tw-px-3 tw-py-1 tw-rounded-full tw-bg-color-surface-sunken tw-text-[13px] tw-font-medium tw-leading-[100%] tw-tracking-normal tw-text-color-text-secondary tw-whitespace-nowrap"
          >
            <span class="tw-w-2 tw-h-2 tw-rounded-full tw-bg-gradient-teal"></span>
            {{ "platinumToGoldRate" | i18n: goldMultiplier }}
          </span>
        </div>

        <div class="tw-flex tw-flex-col tw-gap-2">
          <span
            class="tw-text-[13px] tw-font-medium tw-uppercase tw-tracking-normal tw-text-color-text-secondary"
          >
            {{ "youGetGold" | i18n }}
          </span>
          <div
            class="tw-flex tw-items-center tw-justify-between tw-h-[56px] tw-px-4 tw-py-3 tw-rounded-xl tw-border tw-border-dt-text-today-primary tw-shadow-elevation-input"
            [style.background-image]="youGetGoldBg"
          >
            <span
              class="tw-text-2xl tw-font-semibold tw-font-D-DIN-PRO tw-leading-none tw-tracking-normal tw-text-color-text-default"
            >
              {{ goldPreview() | number }}
            </span>
            <span
              class="tw-text-[13px] tw-font-medium tw-leading-[100%] tw-tracking-normal tw-text-color-text-secondary"
            >
              CrG
            </span>
          </div>
        </div>
      </div>

      <div
        class="tw-flex tw-flex-col tw-gap-2 tw-rounded-2xl tw-bg-white/40 dark:tw-bg-white/[0.06] tw-p-4"
      >
        <span
          class="tw-text-[13px] tw-font-medium tw-uppercase tw-tracking-normal tw-text-color-text-secondary"
        >
          {{ "balanceAfterConversion" | i18n }}
        </span>
        <div
          class="tw-flex tw-items-center tw-justify-between tw-h-[56px] tw-px-4 tw-py-3 tw-rounded-xl tw-border tw-border-dt-text-today-primary tw-bg-color-surface-sunken tw-shadow-elevation-input"
        >
          <span
            class="tw-text-2xl tw-font-semibold tw-font-D-DIN-PRO tw-leading-none tw-tracking-normal tw-text-color-text-default"
          >
            {{ balanceAfterConversion() | number }}
          </span>
          <span
            class="tw-text-[13px] tw-font-medium tw-leading-[100%] tw-tracking-normal tw-text-color-text-secondary"
          >
            CrP
          </span>
        </div>
      </div>

      <button
        type="button"
        (click)="convert()"
        [disabled]="convertDisabled()"
        [style.background]="glassButtonBg"
        [style.box-shadow]="glassButtonShadow"
        class="tw-w-full tw-py-3 tw-rounded-2xl tw-border-[1.5px] tw-border-white/60 dark:tw-border-white/[0.18] tw-text-color-text-on-action tw-font-semibold disabled:tw-opacity-50"
      >
        {{ busy() ? ("processing" | i18n) : ("convertCredits" | i18n) }}
      </button>
    </section>
  }
</div>
